import { SVGProps } from '@components/Icon/types';

export const LockOutlined = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.5C13.3807 10.5 14.5 11.6193 14.5 13C14.5 14.1374 13.7398 15.0954 12.7002 15.3984V17C12.7002 17.3866 12.3866 17.7002 12 17.7002C11.6134 17.7002 11.2998 17.3866 11.2998 17V15.3984C10.2602 15.0954 9.5 14.1374 9.5 13C9.5 11.6193 10.6193 10.5 12 10.5ZM12 11.9004C11.3925 11.9004 10.9004 12.3925 10.9004 13C10.9004 13.6075 11.3925 14.0996 12 14.0996C12.6075 14.0996 13.0996 13.6075 13.0996 13C13.0996 12.3925 12.6075 11.9004 12 11.9004Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 1C15.2091 1 17 2.79086 17 5V6C19.2091 6 21 7.79086 21 10V18C21 20.2091 19.2091 22 17 22H7L6.79395 21.9951C4.68056 21.8879 3 20.14 3 18V10C3 7.79086 4.79086 6 7 6V5C7 2.79086 8.79086 1 11 1H13ZM7 7.40039C5.56406 7.40039 4.40039 8.56406 4.40039 10V18C4.40039 19.4359 5.56406 20.5996 7 20.5996H17C18.4359 20.5996 19.5996 19.4359 19.5996 18V10C19.5996 8.56406 18.4359 7.40039 17 7.40039H7ZM11 2.40039C9.56406 2.40039 8.40039 3.56406 8.40039 5V6H15.5996V5C15.5996 3.56406 14.4359 2.40039 13 2.40039H11Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'lockOutlined';
